// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_scribe_catalog.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * CatalogStatus is the lifecycle state of a scribe catalog entity: encounter
 * schema, document template or analytics model.
 *
 * @generated from enum com.diagnocat.model.CatalogStatus
 */
export const CatalogStatus = proto3.makeEnum(
  "com.diagnocat.model.CatalogStatus",
  [
    {no: 0, name: "CatalogStatusInvalidValue"},
    {no: 1, name: "CatalogStatusActive"},
    {no: 2, name: "CatalogStatusDraft"},
    {no: 3, name: "CatalogStatusDeleted"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.ChecklistGenerationStatus
 */
export const ChecklistGenerationStatus = proto3.makeEnum(
  "com.diagnocat.model.ChecklistGenerationStatus",
  [
    {no: 0, name: "ChecklistGenerationStatusInvalidValue"},
    {no: 1, name: "ChecklistGenerationStatusPending"},
    {no: 2, name: "ChecklistGenerationStatusProcessing"},
    {no: 3, name: "ChecklistGenerationStatusCompleted"},
    {no: 4, name: "ChecklistGenerationStatusFailed"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.RegistryAssetFamily
 */
export const RegistryAssetFamily = proto3.makeEnum(
  "com.diagnocat.model.RegistryAssetFamily",
  [
    {no: 0, name: "RegistryAssetFamilyInvalidValue"},
    {no: 1, name: "RegistryAssetFamilyDocumentTemplate"},
    {no: 2, name: "RegistryAssetFamilyEncounterSchema"},
    {no: 3, name: "RegistryAssetFamilyAnalyticsModel"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.RegistrySourceKind
 */
export const RegistrySourceKind = proto3.makeEnum(
  "com.diagnocat.model.RegistrySourceKind",
  [
    {no: 0, name: "RegistrySourceKindInvalidValue"},
    {no: 1, name: "RegistrySourceKindSystem"},
    {no: 2, name: "RegistrySourceKindCommunity"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.RegistryOriginKind
 */
export const RegistryOriginKind = proto3.makeEnum(
  "com.diagnocat.model.RegistryOriginKind",
  [
    {no: 0, name: "RegistryOriginKindInvalidValue"},
    {no: 1, name: "RegistryOriginKindOfficial"},
    {no: 2, name: "RegistryOriginKindCommunity"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.SchemaDocumentInclusion
 */
export const SchemaDocumentInclusion = proto3.makeEnum(
  "com.diagnocat.model.SchemaDocumentInclusion",
  [
    {no: 0, name: "SchemaDocumentInclusionInvalidValue"},
    {no: 1, name: "SchemaDocumentInclusionAlways"},
    {no: 2, name: "SchemaDocumentInclusionOnDemand"},
  ],
);

/**
 * EncounterKind is the clinical purpose of an encounter schema, copied to the
 * encounters captured under it. It drives the workspace and which documents
 * may draw on the protocol; the document type, not the kind, picks the
 * generator.
 *
 * @generated from enum com.diagnocat.model.EncounterKind
 */
export const EncounterKind = proto3.makeEnum(
  "com.diagnocat.model.EncounterKind",
  [
    {no: 0, name: "EncounterKindInvalidValue"},
    {no: 1, name: "EncounterKindConsultation"},
    {no: 2, name: "EncounterKindTreatment"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteTemplateFormat
 */
export const NoteTemplateFormat = proto3.makeEnum(
  "com.diagnocat.model.NoteTemplateFormat",
  [
    {no: 0, name: "NoteTemplateFormatInvalidValue"},
    {no: 1, name: "NoteTemplateFormatOptions"},
    {no: 2, name: "NoteTemplateFormatBlocks"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteBlockWidget
 */
export const NoteBlockWidget = proto3.makeEnum(
  "com.diagnocat.model.NoteBlockWidget",
  [
    {no: 0, name: "NoteBlockWidgetInvalidValue"},
    {no: 1, name: "NoteBlockWidgetButtons"},
    {no: 2, name: "NoteBlockWidgetDropdown"},
    {no: 3, name: "NoteBlockWidgetPopup"},
    {no: 4, name: "NoteBlockWidgetImages"},
  ],
);

/**
 * The code system of a diagnosis field. Its
 * option codes are the system's codes as written, checked against the
 * system's format; an export gives each as {system, code}.
 *
 * @generated from enum com.diagnocat.model.NoteCodeSystem
 */
export const NoteCodeSystem = proto3.makeEnum(
  "com.diagnocat.model.NoteCodeSystem",
  [
    {no: 0, name: "NoteCodeSystemInvalidValue"},
    {no: 1, name: "NoteCodeSystemICD10"},
    {no: 2, name: "NoteCodeSystemICD10CM"},
    {no: 3, name: "NoteCodeSystemICD11"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteTeethGroup
 */
export const NoteTeethGroup = proto3.makeEnum(
  "com.diagnocat.model.NoteTeethGroup",
  [
    {no: 0, name: "NoteTeethGroupInvalidValue"},
    {no: 1, name: "NoteTeethGroupUpper"},
    {no: 2, name: "NoteTeethGroupLower"},
    {no: 3, name: "NoteTeethGroupUpperRight"},
    {no: 4, name: "NoteTeethGroupUpperLeft"},
    {no: 5, name: "NoteTeethGroupLowerLeft"},
    {no: 6, name: "NoteTeethGroupLowerRight"},
    {no: 7, name: "NoteTeethGroupRight"},
    {no: 8, name: "NoteTeethGroupLeft"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteDentition
 */
export const NoteDentition = proto3.makeEnum(
  "com.diagnocat.model.NoteDentition",
  [
    {no: 0, name: "NoteDentitionInvalidValue"},
    {no: 1, name: "NoteDentitionPermanent"},
    {no: 2, name: "NoteDentitionPrimary"},
    {no: 3, name: "NoteDentitionMixed"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteTeethGranularity
 */
export const NoteTeethGranularity = proto3.makeEnum(
  "com.diagnocat.model.NoteTeethGranularity",
  [
    {no: 0, name: "NoteTeethGranularityInvalidValue"},
    {no: 1, name: "NoteTeethGranularityTooth"},
    {no: 2, name: "NoteTeethGranularitySurface"},
  ],
);

/**
 * @generated from enum com.diagnocat.model.NoteContextKey
 */
export const NoteContextKey = proto3.makeEnum(
  "com.diagnocat.model.NoteContextKey",
  [
    {no: 0, name: "NoteContextKeyInvalidValue"},
    {no: 1, name: "NoteContextKeyClinicianName"},
    {no: 2, name: "NoteContextKeyVisitDate"},
    {no: 3, name: "NoteContextKeyPatientName"},
    {no: 4, name: "NoteContextKeyPatientDateOfBirth"},
  ],
);

/**
 * What a value of a number field is for.
 *
 * @generated from enum com.diagnocat.model.NoteNumberQualifier
 */
export const NoteNumberQualifier = proto3.makeEnum(
  "com.diagnocat.model.NoteNumberQualifier",
  [
    {no: 0, name: "NoteNumberQualifierInvalidValue"},
    {no: 1, name: "NoteNumberQualifierRight"},
    {no: 2, name: "NoteNumberQualifierLeft"},
    {no: 3, name: "NoteNumberQualifierUpper"},
    {no: 4, name: "NoteNumberQualifierLower"},
    {no: 5, name: "NoteNumberQualifierFront"},
  ],
);

/**
 * What a cell of a table column holds.
 *
 * @generated from enum com.diagnocat.model.NoteTableCellType
 */
export const NoteTableCellType = proto3.makeEnum(
  "com.diagnocat.model.NoteTableCellType",
  [
    {no: 0, name: "NoteTableCellTypeInvalidValue"},
    {no: 1, name: "NoteTableCellTypeCheckbox"},
    {no: 2, name: "NoteTableCellTypeDate"},
    {no: 3, name: "NoteTableCellTypeText"},
    {no: 4, name: "NoteTableCellTypeNumber"},
    {no: 5, name: "NoteTableCellTypeTooth"},
  ],
);

/**
 * PartnerTemplatePartner names the external system a partner template was
 * converted from.
 *
 * @generated from enum com.diagnocat.model.PartnerTemplatePartner
 */
export const PartnerTemplatePartner = proto3.makeEnum(
  "com.diagnocat.model.PartnerTemplatePartner",
  [
    {no: 0, name: "PartnerTemplatePartnerInvalidValue"},
    {no: 1, name: "PartnerTemplatePartnerDentalPro"},
  ],
);

/**
 * RegistryAsset is one row of the cross-family catalog browser: encounter
 * schemas, document templates and analytics models an organization can adopt,
 * in one listing. The per-family count fields are set only for the family the
 * row belongs to.
 *
 * @generated from message com.diagnocat.model.RegistryAsset
 */
export const RegistryAsset = proto3.makeMessageType(
  "com.diagnocat.model.RegistryAsset",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Family", kind: "enum", T: proto3.getEnumType(RegistryAssetFamily) },
    { no: 3, name: "SourceKind", kind: "enum", T: proto3.getEnumType(RegistrySourceKind) },
    { no: 4, name: "OriginKind", kind: "enum", T: proto3.getEnumType(RegistryOriginKind) },
    { no: 5, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "TemplateType", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "SectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "DocumentCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "AnalyticsGroupsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 12, name: "AnalyticsSectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "AuthorDisplayName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "AuthorSpecialty", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "ImportCount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 18, name: "HasLocalClone", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "LocalCloneID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "Classification", kind: "message", T: TemplateClassification, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.EncounterSchema
 */
export const EncounterSchema = proto3.makeMessageType(
  "com.diagnocat.model.EncounterSchema",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 5, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 13, name: "AnalyticsModelSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
    { no: 15, name: "AlwaysDocumentCodes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "OnDemandDocumentCodes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "AlwaysDocumentSeriesIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "OnDemandDocumentSeriesIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "DocumentCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 21, name: "CreatedBy", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "Kind", kind: "enum", T: proto3.getEnumType(EncounterKind) },
    { no: 23, name: "AddedByClinic", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 24, name: "TranscriptorV2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * EncounterSchemaSummary is the list projection of EncounterSchema: it keeps
 * the document refs but drops the derived code and series-id lists.
 *
 * @generated from message com.diagnocat.model.EncounterSchemaSummary
 */
export const EncounterSchemaSummary = proto3.makeMessageType(
  "com.diagnocat.model.EncounterSchemaSummary",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 5, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "AnalyticsModelSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
    { no: 14, name: "DocumentCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 16, name: "Kind", kind: "enum", T: proto3.getEnumType(EncounterKind) },
    { no: 17, name: "AddedByClinic", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 18, name: "TranscriptorV2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * SchemaDocumentRefList carries a document list where an unset list has to
 * mean something different from an empty one: proto3 gives a bare repeated
 * field no presence, so an update could never clear the last document.
 *
 * @generated from message com.diagnocat.model.SchemaDocumentRefList
 */
export const SchemaDocumentRefList = proto3.makeMessageType(
  "com.diagnocat.model.SchemaDocumentRefList",
  () => [
    { no: 1, name: "Documents", kind: "message", T: SchemaDocumentRef, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.SchemaDocumentRef
 */
export const SchemaDocumentRef = proto3.makeMessageType(
  "com.diagnocat.model.SchemaDocumentRef",
  () => [
    { no: 1, name: "TemplateSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Inclusion", kind: "enum", T: proto3.getEnumType(SchemaDocumentInclusion) },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * SchemaUsageSummary counts the encounters actually captured under a schema
 * code, which can differ from the catalog in both directions: a seeded schema
 * nobody used yet is absent, a custom schema captured on encounters but never
 * added to the catalog is present.
 *
 * @generated from message com.diagnocat.model.SchemaUsageSummary
 */
export const SchemaUsageSummary = proto3.makeMessageType(
  "com.diagnocat.model.SchemaUsageSummary",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.DocumentTemplate
 */
export const DocumentTemplate = proto3.makeMessageType(
  "com.diagnocat.model.DocumentTemplate",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "Sections", kind: "message", T: DocumentSectionSpec, repeated: true },
    { no: 17, name: "CatalogListing", kind: "message", T: CatalogListing, opt: true },
    { no: 18, name: "CatalogPublished", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "Checklist", kind: "message", T: TemplateChecklist, opt: true },
    { no: 22, name: "SourceDocument", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 21, name: "UpdatedAt", kind: "message", T: Timestamp, opt: true },
    { no: 23, name: "Format", kind: "enum", T: proto3.getEnumType(NoteTemplateFormat) },
    { no: 24, name: "Classification", kind: "message", T: TemplateClassification, opt: true },
    { no: 25, name: "PartnerSource", kind: "message", T: PartnerTemplateSource, opt: true },
    { no: 26, name: "EditedByClinic", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 27, name: "AddedByClinic", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 28, name: "TranscriptorV2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * DocumentTemplateSummary is the list projection of DocumentTemplate: every
 * field except Sections, CatalogListing and Checklist.
 *
 * @generated from message com.diagnocat.model.DocumentTemplateSummary
 */
export const DocumentTemplateSummary = proto3.makeMessageType(
  "com.diagnocat.model.DocumentTemplateSummary",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "SectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "CatalogPublished", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 18, name: "UpdatedAt", kind: "message", T: Timestamp, opt: true },
    { no: 19, name: "Format", kind: "enum", T: proto3.getEnumType(NoteTemplateFormat) },
    { no: 20, name: "Classification", kind: "message", T: TemplateClassification, opt: true },
    { no: 21, name: "PartnerSource", kind: "message", T: PartnerTemplateSource, opt: true },
    { no: 22, name: "EditedByClinic", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 23, name: "AddedByClinic", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 24, name: "NewerCommunityTemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 25, name: "TranscriptorV2", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.DocumentSectionSpec
 */
export const DocumentSectionSpec = proto3.makeMessageType(
  "com.diagnocat.model.DocumentSectionSpec",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "EditorType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ProcessingType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "Options", kind: "message", T: SectionOption, repeated: true },
    { no: 10, name: "TemplateType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "Lines", kind: "message", T: NoteLine, repeated: true },
    { no: 13, name: "AllowAITextRewrite", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.SectionOption
 */
export const SectionOption = proto3.makeMessageType(
  "com.diagnocat.model.SectionOption",
  () => [
    { no: 1, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Slots", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SlotValues} },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "SlotInstructions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message com.diagnocat.model.SlotValues
 */
export const SlotValues = proto3.makeMessageType(
  "com.diagnocat.model.SlotValues",
  () => [
    { no: 1, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * NoteLine is one row of a block note: its blocks read left to right as one
 * sentence.
 *
 * @generated from message com.diagnocat.model.NoteLine
 */
export const NoteLine = proto3.makeMessageType(
  "com.diagnocat.model.NoteLine",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Blocks", kind: "message", T: NoteBlock, repeated: true },
    { no: 3, name: "ShowWhen", kind: "message", T: NoteShowWhen, repeated: true },
    { no: 4, name: "Subheading", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * NoteShowWhen holds while block BlockID sits on a shown, open line and holds a
 * value equal to one of Values, compared ignoring case and spacing. "Other"
 * text never matches.
 *
 * @generated from message com.diagnocat.model.NoteShowWhen
 */
export const NoteShowWhen = proto3.makeMessageType(
  "com.diagnocat.model.NoteShowWhen",
  () => [
    { no: 1, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * One option of a choice or multi_choice.
 *
 * @generated from message com.diagnocat.model.NoteOption
 */
export const NoteOption = proto3.makeMessageType(
  "com.diagnocat.model.NoteOption",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Print", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "AIHint", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Image", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * NoteBlock is one typed piece of a line.
 *
 * @generated from message com.diagnocat.model.NoteBlock
 */
export const NoteBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteBlock",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Text", kind: "message", T: NoteTextBlock, oneof: "Kind" },
    { no: 3, name: "Choice", kind: "message", T: NoteChoiceBlock, oneof: "Kind" },
    { no: 4, name: "MultiChoice", kind: "message", T: NoteMultiChoiceBlock, oneof: "Kind" },
    { no: 5, name: "Teeth", kind: "message", T: NoteTeethBlock, oneof: "Kind" },
    { no: 6, name: "FreeText", kind: "message", T: NoteFreeTextBlock, oneof: "Kind" },
    { no: 7, name: "Context", kind: "message", T: NoteContextBlock, oneof: "Kind" },
    { no: 8, name: "ListRef", kind: "message", T: NoteListRefBlock, oneof: "Kind" },
    { no: 10, name: "Number", kind: "message", T: NoteNumberBlock, oneof: "Kind" },
    { no: 11, name: "Date", kind: "message", T: NoteDateBlock, oneof: "Kind" },
    { no: 12, name: "Table", kind: "message", T: NoteTableBlock, oneof: "Kind" },
    { no: 20, name: "SlotID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "Default", kind: "message", T: NoteBlockDefault, opt: true },
    { no: 23, name: "AIInstruction", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * NoteBlockDefault is a block's starting value (NoteBlock.Default), shaped as
 * the block's manual answer (DocumentAnswerChange) and checked by the same
 * manual rule. It holds a value: an empty default is refused.
 *
 * @generated from message com.diagnocat.model.NoteBlockDefault
 */
export const NoteBlockDefault = proto3.makeMessageType(
  "com.diagnocat.model.NoteBlockDefault",
  () => [
    { no: 1, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "Text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Teeth", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "TeethGroups", kind: "enum", T: proto3.getEnumType(NoteTeethGroup), repeated: true },
    { no: 5, name: "Date", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "None", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "Marks", kind: "message", T: NoteToothMark, repeated: true },
    { no: 8, name: "Numbers", kind: "message", T: NoteNumberValue, repeated: true },
    { no: 9, name: "TableRows", kind: "message", T: NoteTableRowValue, repeated: true },
  ],
);

/**
 * Fixed wording, printed verbatim with its spaces. It is part of the note
 * unless its line is hidden, deleted or skipped. On a note the clinician may
 * override it, and the after-Stop AI step may rewrite it once while nobody has
 * and the effective rewrite permission allows it.
 *
 * @generated from message com.diagnocat.model.NoteTextBlock
 */
export const NoteTextBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteTextBlock",
  () => [
    { no: 1, name: "Value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "AllowAITextRewrite", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * Exactly one value (button group or dropdown).
 *
 * @generated from message com.diagnocat.model.NoteChoiceBlock
 */
export const NoteChoiceBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteChoiceBlock",
  () => [
    { no: 1, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "OtherAllowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "Widget", kind: "enum", T: proto3.getEnumType(NoteBlockWidget) },
    { no: 4, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Options", kind: "message", T: NoteOption, repeated: true },
    { no: 6, name: "AllowNone", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "NoneLabel", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "CodeSystem", kind: "enum", T: proto3.getEnumType(NoteCodeSystem), opt: true },
  ],
);

/**
 * One or more values, printed with the template language's joiner.
 *
 * @generated from message com.diagnocat.model.NoteMultiChoiceBlock
 */
export const NoteMultiChoiceBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteMultiChoiceBlock",
  () => [
    { no: 1, name: "Values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "OtherAllowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "Widget", kind: "enum", T: proto3.getEnumType(NoteBlockWidget) },
    { no: 4, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Options", kind: "message", T: NoteOption, repeated: true },
    { no: 6, name: "AllowNone", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "NoneLabel", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "CodeSystem", kind: "enum", T: proto3.getEnumType(NoteCodeSystem), opt: true },
  ],
);

/**
 * Teeth selector. Answers store canonical FDI numbers; the note prints them in
 * the notation snapshotted on the note (ISO or Universal).
 *
 * @generated from message com.diagnocat.model.NoteTeethBlock
 */
export const NoteTeethBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteTeethBlock",
  () => [
    { no: 1, name: "Multiple", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 2, name: "Groups", kind: "enum", T: proto3.getEnumType(NoteTeethGroup), repeated: true },
    { no: 3, name: "Dentition", kind: "enum", T: proto3.getEnumType(NoteDentition) },
    { no: 4, name: "Teeth", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "Granularity", kind: "enum", T: proto3.getEnumType(NoteTeethGranularity) },
    { no: 7, name: "Codes", kind: "message", T: NoteToothCode, repeated: true },
    { no: 8, name: "OneCodePerTooth", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "Unit", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "Precision", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 11, name: "AllowNone", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 12, name: "NoneLabel", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * One code of a teeth field (NoteTeethBlock.Codes).
 *
 * @generated from message com.diagnocat.model.NoteToothCode
 */
export const NoteToothCode = proto3.makeMessageType(
  "com.diagnocat.model.NoteToothCode",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Short", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Dentition", kind: "enum", T: proto3.getEnumType(NoteDentition) },
  ],
);

/**
 * What a teeth field holds on one tooth or one of its surfaces: its codes, or
 * its number. A change or a default may name a Group instead of a Tooth: the
 * mark is set on every tooth of the group the field offers, and stored per
 * tooth.
 *
 * @generated from message com.diagnocat.model.NoteToothMark
 */
export const NoteToothMark = proto3.makeMessageType(
  "com.diagnocat.model.NoteToothMark",
  () => [
    { no: 1, name: "Tooth", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Surface", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "Number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Group", kind: "enum", T: proto3.getEnumType(NoteTeethGroup) },
  ],
);

/**
 * Free text on the line ("Enter notes here…").
 *
 * @generated from message com.diagnocat.model.NoteFreeTextBlock
 */
export const NoteFreeTextBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteFreeTextBlock",
  () => [
    { no: 1, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * A value scribe resolves from core and snapshots on the note; the model never
 * fills it. The clinician may override it.
 *
 * @generated from message com.diagnocat.model.NoteContextBlock
 */
export const NoteContextBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteContextBlock",
  () => [
    { no: 1, name: "Key", kind: "enum", T: proto3.getEnumType(NoteContextKey) },
  ],
);

/**
 * A choice from a shared list. The list is read when the note is filled; the
 * answer keeps the chosen text, so a later list edit never changes a note.
 *
 * @generated from message com.diagnocat.model.NoteListRefBlock
 */
export const NoteListRefBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteListRefBlock",
  () => [
    { no: 1, name: "ListID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Multiple", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 3, name: "OtherAllowed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "Widget", kind: "enum", T: proto3.getEnumType(NoteBlockWidget) },
    { no: 5, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "AllowNone", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "NoneLabel", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "CodeSystem", kind: "enum", T: proto3.getEnumType(NoteCodeSystem), opt: true },
  ],
);

/**
 * A calendar date. The answer stores it as YYYY-MM-DD
 * (DocumentAnswer.Date); the note prints it in the template language's date
 * format. Entered by the clinician: the AI steps never fill it.
 *
 * @generated from message com.diagnocat.model.NoteDateBlock
 */
export const NoteDateBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteDateBlock",
  () => [
    { no: 1, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * A number field: a decimal in the
 * field's unit, one value, or one for each of its qualifiers.
 *
 * @generated from message com.diagnocat.model.NoteNumberBlock
 */
export const NoteNumberBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteNumberBlock",
  () => [
    { no: 1, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "Unit", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Precision", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 4, name: "Min", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Max", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "Qualifiers", kind: "enum", T: proto3.getEnumType(NoteNumberQualifier), repeated: true },
  ],
);

/**
 * One value of a number field: a decimal, "." separated, and its qualifier
 * (unset on a field without qualifiers).
 *
 * @generated from message com.diagnocat.model.NoteNumberValue
 */
export const NoteNumberValue = proto3.makeMessageType(
  "com.diagnocat.model.NoteNumberValue",
  () => [
    { no: 1, name: "Qualifier", kind: "enum", T: proto3.getEnumType(NoteNumberQualifier) },
    { no: 2, name: "Value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * A grid of typed cells: columns, each with the type
 * of its cells, and rows the template fixes or the note adds. The answer
 * holds every cell of every row, an empty or unchecked one too
 * (DocumentAnswer.TableRows); the note prints it row by row.
 *
 * @generated from message com.diagnocat.model.NoteTableBlock
 */
export const NoteTableBlock = proto3.makeMessageType(
  "com.diagnocat.model.NoteTableBlock",
  () => [
    { no: 1, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "Columns", kind: "message", T: NoteTableColumn, repeated: true },
    { no: 3, name: "Rows", kind: "message", T: NoteTableRow, repeated: true },
    { no: 4, name: "AddRows", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * One column of a table.
 *
 * @generated from message com.diagnocat.model.NoteTableColumn
 */
export const NoteTableColumn = proto3.makeMessageType(
  "com.diagnocat.model.NoteTableColumn",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Type", kind: "enum", T: proto3.getEnumType(NoteTableCellType) },
    { no: 4, name: "Unit", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Precision", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * One fixed row of a table.
 *
 * @generated from message com.diagnocat.model.NoteTableRow
 */
export const NoteTableRow = proto3.makeMessageType(
  "com.diagnocat.model.NoteTableRow",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * One row of a table value: a fixed row by its code, or a row added on the
 * note by its id (`rw_` + 10 base32 characters; a change or a default may
 * leave it empty for a new row, and scribe mints it), with its cells.
 *
 * @generated from message com.diagnocat.model.NoteTableRowValue
 */
export const NoteTableRowValue = proto3.makeMessageType(
  "com.diagnocat.model.NoteTableRowValue",
  () => [
    { no: 1, name: "Row", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Cells", kind: "message", T: NoteTableCellValue, repeated: true },
  ],
);

/**
 * One cell of a table value: its column's code and its value as the column's
 * type writes it ("" for an empty cell, "false" for an unchecked box).
 *
 * @generated from message com.diagnocat.model.NoteTableCellValue
 */
export const NoteTableCellValue = proto3.makeMessageType(
  "com.diagnocat.model.NoteTableCellValue",
  () => [
    { no: 1, name: "Column", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * NoteList is a shared value list (anaesthetics, materials, labs). An edit
 * reaches every template that references it.
 *
 * @generated from message com.diagnocat.model.NoteList
 */
export const NoteList = proto3.makeMessageType(
  "com.diagnocat.model.NoteList",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "Items", kind: "message", T: NoteListItem, repeated: true },
    { no: 9, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 10, name: "Revision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "CreatedAt", kind: "message", T: Timestamp },
    { no: 13, name: "UpdatedAt", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.NoteListItem
 */
export const NoteListItem = proto3.makeMessageType(
  "com.diagnocat.model.NoteListItem",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * DocumentTemplateIssue is one problem found in a template or list write. A
 * refused write attaches the refusals as Connect error details next to the
 * readable message, so clients show them without parsing text; Create and
 * UpdateDraft return non-blocking `warning_*` issues in their response.
 *
 * @generated from message com.diagnocat.model.DocumentTemplateIssue
 */
export const DocumentTemplateIssue = proto3.makeMessageType(
  "com.diagnocat.model.DocumentTemplateIssue",
  () => [
    { no: 1, name: "Kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SectionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "LineID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "BlockID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.TemplateChecklist
 */
export const TemplateChecklist = proto3.makeMessageType(
  "com.diagnocat.model.TemplateChecklist",
  () => [
    { no: 1, name: "Status", kind: "enum", T: proto3.getEnumType(ChecklistGenerationStatus) },
    { no: 2, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "Content", kind: "message", T: ChecklistContent, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.ChecklistContent
 */
export const ChecklistContent = proto3.makeMessageType(
  "com.diagnocat.model.ChecklistContent",
  () => [
    { no: 1, name: "Items", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "GeneratedAt", kind: "message", T: Timestamp },
    { no: 3, name: "Model", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * TemplateClassification places a template in the catalog taxonomy: a
 * department and one group of that department, as stable ids from scribe's
 * closed vocabulary (`dental.surgery`, `dental.surgery.extraction`). Clients
 * show localized labels. A copy keeps the classification of its source.
 *
 * @generated from message com.diagnocat.model.TemplateClassification
 */
export const TemplateClassification = proto3.makeMessageType(
  "com.diagnocat.model.TemplateClassification",
  () => [
    { no: 1, name: "Department", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * PartnerTemplateSource ties a template to the partner template it was
 * converted from. The partner's text itself is the template's SourceDocument,
 * in Format; exporting a note back to the partner rewrites that text.
 *
 * @generated from message com.diagnocat.model.PartnerTemplateSource
 */
export const PartnerTemplateSource = proto3.makeMessageType(
  "com.diagnocat.model.PartnerTemplateSource",
  () => [
    { no: 1, name: "Partner", kind: "enum", T: proto3.getEnumType(PartnerTemplatePartner) },
    { no: 2, name: "ExternalID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * CatalogListing is what an organization wrote about its own template when it
 * published it. Specialty and Category fall back to catalog defaults when the
 * publisher left them empty.
 *
 * @generated from message com.diagnocat.model.CatalogListing
 */
export const CatalogListing = proto3.makeMessageType(
  "com.diagnocat.model.CatalogListing",
  () => [
    { no: 1, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Location", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "ImportCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "PublishedAt", kind: "message", T: Timestamp, opt: true },
  ],
);

/**
 * CommunityDocumentTemplate is a published template as the community catalog
 * presents it, with its publisher attribution resolved.
 *
 * @generated from message com.diagnocat.model.CommunityDocumentTemplate
 */
export const CommunityDocumentTemplate = proto3.makeMessageType(
  "com.diagnocat.model.CommunityDocumentTemplate",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "TabTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "Specialty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "Category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "Location", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "Tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "AuthorDisplayName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "AuthorSpecialty", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "SourceTemplateID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "SourceSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "SourceOrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "Sections", kind: "message", T: DocumentSectionSpec, repeated: true },
    { no: 18, name: "ImportCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "SectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "PublishedAt", kind: "message", T: Timestamp, opt: true },
    { no: 21, name: "Format", kind: "enum", T: proto3.getEnumType(NoteTemplateFormat) },
    { no: 22, name: "Lists", kind: "message", T: NoteList, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsModel
 */
export const AnalyticsModel = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsModel",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "IsSystem", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "Tags", kind: "message", T: AnalyticsTagsConfig },
    { no: 14, name: "Sections", kind: "message", T: AnalyticsSectionSpec, repeated: true },
    { no: 15, name: "AnalyticsGroupsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "AnalyticsSectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * AnalyticsModelSummary is the list projection of AnalyticsModel: every field
 * except Tags and Sections.
 *
 * @generated from message com.diagnocat.model.AnalyticsModelSummary
 */
export const AnalyticsModelSummary = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsModelSummary",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "SeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Status", kind: "enum", T: proto3.getEnumType(CatalogStatus) },
    { no: 7, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "SourceKind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "DerivedFromKind", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "DerivedFromID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "AnalyticsGroupsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "AnalyticsSectionsCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "CreatedAt", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsTagsConfig
 */
export const AnalyticsTagsConfig = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsTagsConfig",
  () => [
    { no: 1, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "Groups", kind: "message", T: AnalyticsTagGroup, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsTagGroup
 */
export const AnalyticsTagGroup = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsTagGroup",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "SelectionMode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "Tags", kind: "message", T: AnalyticsTagSpec, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsTagSpec
 */
export const AnalyticsTagSpec = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsTagSpec",
  () => [
    { no: 1, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "Explain", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * AnalyticsSectionSpecList carries a section list with presence, for the same
 * reason as SchemaDocumentRefList.
 *
 * @generated from message com.diagnocat.model.AnalyticsSectionSpecList
 */
export const AnalyticsSectionSpecList = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsSectionSpecList",
  () => [
    { no: 1, name: "Sections", kind: "message", T: AnalyticsSectionSpec, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AnalyticsSectionSpec
 */
export const AnalyticsSectionSpec = proto3.makeMessageType(
  "com.diagnocat.model.AnalyticsSectionSpec",
  () => [
    { no: 1, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Instructions", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * CatalogCloneOverride names one source asset to clone into the target
 * organization, optionally renaming it. Shared by the clone RPCs of all three
 * catalog services.
 *
 * @generated from message com.diagnocat.model.CatalogCloneOverride
 */
export const CatalogCloneOverride = proto3.makeMessageType(
  "com.diagnocat.model.CatalogCloneOverride",
  () => [
    { no: 1, name: "Family", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "SourceAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.CatalogCloneResult
 */
export const CatalogCloneResult = proto3.makeMessageType(
  "com.diagnocat.model.CatalogCloneResult",
  () => [
    { no: 1, name: "LocalAssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "LocalSeriesID", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "ReusedExisting", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

